import React from 'react';
import Image from 'react-image'
import NoImage from 'assets/images/no-image.jpg'
import PropTypes from 'prop-types';

const Space = ({ title, address, image, spaceUrl }) => (
  <>
    <p className="inquiry-data-label text-gray-500 font-bold text-xs mb-1">SPACE</p>
    <div className="inquiry-space flex justify-start items-start mb-8">
      <Image src={[image, NoImage]} className="rounded shadow w-24 h-16 mr-5" />
      <div className="details">
        <a target='_bank' href={spaceUrl}>
          <p className="text-sm text-orange-400 font-medium">{title}</p>
        </a>
        <p className="text-sm text-gray-600">{address}</p>
      </div>
    </div>
  </>
);

Space.propTypes = {
  title: PropTypes.string,
  address: PropTypes.string,
  image: PropTypes.string,
  spaceUrl: PropTypes.string
}

export default Space;
